<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2 >लेनदेन </h2>
        </div>
        <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a> 
        </div>
        <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='26'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
            (mouseout)="showpayment(false,'2')" id="27">

         
            <label for="" class="mt-2" >लेन-देन किसी भी भुगतान प्रसंस्करण
                प्रणाली के केंद्र में हैं, जिसमें पे जी जैसे भुगतान गेटवे भी शामिल हैं। सरल
                शब्दों में, लेन-देन एक ग्राहक और आपके व्यवसाय के बीच मूल्य का आदान-प्रदान
                है, जो भुगतान गेटवे के माध्यम से सुगम होता है। </label>
          
            <label for="" class="mt-2" >लेन-देन वस्तुओं या सेवाओं के भुगतान के
                रूप में किसी ग्राहक के खाते से आपके व्यावसायिक खाते में धनराशि स्थानांतरित
                करने की प्रक्रिया को संदर्भित करता है। इस प्रक्रिया में यह सुनिश्चित करने के
                लिए कई चरण शामिल हैं कि भुगतान सुरक्षित रूप से संसाधित, अधिकृत और निपटान
                किया गया है। </label>
        </div>
        <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="28">
            <h2 >लेन-देन के प्रमुख तत्व </h2>
            <ol>
                <li class="mt-3" ><b>शुरुआत:</b> &nbsp;लेन-देन तब शुरू होता है
                    जब कोई ग्राहक आपकी वेबसाइट पर या किसी अन्य चैनल के माध्यम से किसी उत्पाद
                    या सेवा के लिए भुगतान शुरू करता है।
                </li>

                <li class="mt-3" ><b>प्राधिकरण: </b> &nbsp;एक बार जब ग्राहक
                    भुगतान शुरू कर देता है, तो लेनदेन डेटा सुरक्षित रूप से भुगतान गेटवे पर
                    प्रेषित किया जाता है, जो भुगतान के लिए प्राधिकरण प्राप्त करने के लिए
                    ग्राहक के जारीकर्ता बैंक या वित्तीय संस्थान के साथ संचार करता है। यह कदम
                    सुनिश्चित करता है कि ग्राहक के पास लेनदेन पूरा करने के लिए पर्याप्त
                    धनराशि या क्रेडिट है। </li>

                <li class="mt-3" ><b>प्रमाणीकरण:</b> &nbsp;सुरक्षा उपायों के
                    आधार पर, ग्राहक को अपनी पहचान की पुष्टि करने और लेनदेन को मंजूरी देने के
                    लिए अतिरिक्त प्रमाणीकरण, जैसे वन-टाइम पासवर्ड (ओटीपी) या बायोमेट्रिक
                    सत्यापन प्रदान करने की आवश्यकता हो सकती है। </li>

                <li class="mt-3" ><b> प्रसंस्करण: </b> &nbsp;प्राधिकरण और
                    प्रमाणीकरण प्राप्त करने के बाद, भुगतान गेटवे भुगतान संसाधित करता है। यह
                    सुरक्षित रूप से भुगतान विवरण को व्यापारी के अधिग्रहणकर्ता बैंक तक
                    पहुंचाता है, जो फिर व्यापारी के खाते में धनराशि स्थानांतरित करता है।
                </li>

                <li class="mt-3" ><b>निपटान:</b> &nbsp;Tनिपटान धनराशि ग्राहक के
                    खाते से आपके व्यावसायिक खाते में स्थानांतरित कर दी जाती है, आमतौर पर कुछ
                    व्यावसायिक दिनों के भीतर। यह चरण लेन-देन पूरा करता है| </li>

                <li class="mt-3" ><b>पुष्टिकरण:</b> &nbsp;व्यापारी और ग्राहक के
                    रूप में आप दोनों को सफल लेनदेन की पुष्टि प्राप्त होती है। ग्राहक को
                    आमतौर पर भुगतान रसीद प्राप्त होती है, जबकि आपको भुगतान और उसके विवरण की
                    अधिसूचना प्राप्त होती है।
                </li>
            </ol>
        </div>
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')"
            (mouseout)="showpayment(false,'4')" id="29">
            <h2 >
                सुरक्षा उपाय
            </h2>
            <label for="" class="mt-2" >यह सुनिश्चित करने के लिए कि लेनदेन
                सुरक्षित हैं और अनधिकृत पहुंच या डेटा उल्लंघनों से सुरक्षित हैं, पे जी
                एन्क्रिप्शन, टोकनाइजेशन और धोखाधड़ी का पता लगाने सहित विभिन्न सुरक्षा उपायों
                को लागू करता है।

            </label>
        </div>

        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')"
            (mouseout)="showpayment(false,'5')" id="30">
            <h2 >
                विश्वसनीय लेनदेन का महत्व
            </h2>
            <label for="" class="mt-3" >आपके ग्राहकों के साथ विश्वास कायम करने
                के लिए विश्वसनीय और सुरक्षित लेनदेन आवश्यक हैं। एक सहज और सुरक्षित भुगतान
                अनुभव प्रदान करके, आप ग्राहकों की संतुष्टि बढ़ाते हैं और दोबारा व्यापार करने
                की संभावना बढ़ाते हैं। याद रखें, पे जी इन लेनदेन को कुशलतापूर्वक और सुरक्षित
                रूप से सुविधाजनक बनाने के लिए यहां है, जिससे आप भुगतान प्रसंस्करण के तकनीकी
                पहलुओं को संभालने के साथ-साथ अपने व्यवसाय को बढ़ाने पर ध्यान केंद्रित कर
                सकते हैं। यदि आपके कोई प्रश्न हैं या सहायता की आवश्यकता है, तो हमारी सहायता
                टीम हमेशा मदद के लिए तैयार है।
            </label>
        </div>
    </div>
</div>
</div>
<div class="col-md-4  hide-tbl content2  ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
            <h5 >
                विषयसूची:
            </h5>
        </div>
        <!-- <div class="col-md-12 mt-2">
           <a href="#26">  <div class="row">
                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">
                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        PayG’s Transactions </span>
                </div>
            </div></a>
        </div> -->
        <div class="col-md-12 mt-2">
            <a href="#27">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            >
                            पे जी के लेनदेन </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#28">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >महत्वपूर्ण तत्व
                        </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#29">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                            >सुरक्षा उपाय </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#30">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                            >लेन-देन का महत्व </span>
                    </div>
                </div>
            </a>
        </div>

    </div>
</div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
           
            <a [routerLink]="['/video-kyc']"> <button class="btn btn-color" (click)="menues('Video KYC')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;वीडियो केवाईसी

            </button></a>
        </div>
        <div class="col-md-4    ">
            <a [routerLink]="['/refunds']"> <button class="btn btn-color" (click)="menues('Refunds')" >रिफंड
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
        </div>
    </div>
</div>
</div>
